export default __webpack_public_path__ + "static/media/area-79.cd12ff66.jpg";